module.exports = __webpack_public_path__ + "img/circle_graph.3c96dacb.svg";